import diamondbacks from "./diamondbacks.png";
import braves from "./braves.png";
import orioles from "./orioles.png";
import redsox from "./redsox.png";
import cubs from "./cubs.png";
import whitesox from "./whitesox.png";
import reds from "./reds.png";
import guardians from "./guardians.png";
import rockies from "./rockies.png";
import tigers from "./tigers.png";
import astros from "./astros.png";
import royals from "./royals.png";
import angels from "./angels.png";
import dodgers from "./dodgers.png";
import marlins from "./marlins.png";
import brewers from "./brewers.png";
import twins from "./twins.png";
import mets from "./mets.png";
import yankees from "./yankees.png";
import athletics from "./athletics.png";
import phillies from "./phillies.png";
import pirates from "./pirates.png";
import padres from "./padres.png";
import giants from "./giants.png";
import mariners from "./mariners.png";
import cardinals from "./cardinals.png";
import rays from "./rays.png";
import rangers from "./rangers.png";
import bluejays from "./bluejays.png";
import nationals from "./nationals.png";

const images = {
  diamondbacks: diamondbacks,
  braves: braves,
  orioles: orioles,
  redsox: redsox,
  cubs: cubs,
  whitesox: whitesox,
  reds: reds,
  guardians: guardians,
  rockies: rockies,
  tigers: tigers,
  astros: astros,
  royals: royals,
  angels: angels,
  dodgers: dodgers,
  marlins: marlins,
  brewers: brewers,
  twins: twins,
  mets: mets,
  yankees: yankees,
  athletics: athletics,
  phillies: phillies,
  pirates: pirates,
  padres: padres,
  giants: giants,
  mariners: mariners,
  cardinals: cardinals,
  rays: rays,
  rangers: rangers,
  bluejays: bluejays,
  nationals: nationals,
};

export default images;
